'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'i18n/routing';
import { useMessagePort } from '.';

const CONFIRM_BEFORE_CLOSE_PATH_PREFIXES = ['/designer', '/cart'];

const shouldConfirmBeforeClose = (pathname: string) =>
  CONFIRM_BEFORE_CLOSE_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

const ConfirmBeforeCloseMessenger = () => {
  const pathname = usePathname();
  const { isReady, sendConfirmBeforeClose } = useMessagePort();
  const lastSentState = useRef<boolean | undefined>(undefined);
  const sendConfirmBeforeCloseRef = useRef(sendConfirmBeforeClose);

  useEffect(() => {
    sendConfirmBeforeCloseRef.current = sendConfirmBeforeClose;
  }, [sendConfirmBeforeClose]);

  useEffect(() => {
    if (!isReady) return;

    const state = shouldConfirmBeforeClose(pathname);
    if (lastSentState.current === state) return;

    sendConfirmBeforeClose(state);
    lastSentState.current = state;
  }, [isReady, pathname, sendConfirmBeforeClose]);

  // Cleanup, when this component is unmounted we reset the confirmBeforeClose state to false
  useEffect(
    () => () => {
      if (lastSentState.current) {
        sendConfirmBeforeCloseRef.current(false);
      }
      lastSentState.current = undefined;
    },
    [],
  );

  return null;
};

export default ConfirmBeforeCloseMessenger;
